// avstemming-payroll-messages-part2 translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'ave.sec.src.complete': 'Completo',
  'ave.sec.src.notRelevant': 'No aplica',
  'ave.sec.row.notCompared': 'No comparado',
  'ave.sec.run.done': 'Completado y conciliado',
  'ave.sec.run.draft': 'Borrador — no contabilizado',
  'ave.sec.run.ameldingMissing': 'Falta la A-melding',
  'ave.sec.run.notPaid': 'No pagado',
  'ave.sec.run.paidAfter': 'Pagado después de la fecha del periodo',
  'ave.sec.sourcesTitle': 'Fuentes de datos',
  'ave.sec.thSource': 'Fuente',
  'ave.sec.thDetails': 'Detalles',
  'ave.sec.sourcesNote': 'La A-melding y el pago bancario se registran actualmente fuera de Plumme. La conciliación puede confirmar que un proceso se ha declarado y pagado, pero no lo que respondieron Altinn o el banco.',
  'ave.sec.mainTitle': 'Conciliación principal automática',
  'ave.sec.nothingToCompare': 'No hay cifras que comparar',
  'ave.sec.deviations': '{count} diferencias',
  'ave.sec.mainMatches': 'El sistema de nómina y el libro mayor cuadran en conjunto',
  'ave.sec.thArea': 'Área de control',
  'ave.sec.thPayrollSystem': 'Sistema de nómina',
  'ave.sec.thLedger': 'Libro mayor',
  'ave.sec.mainNote': '{settled} de {comparable} áreas de control comparables cuadran. Las celdas vacías significan que la fuente no tiene la cifra — no que el importe sea cero.',
  'ave.sec.accountsTitle': 'Cuentas de control en el libro mayor',
  'ave.sec.noAccounts': 'No se ha añadido ninguna cuenta al área de nómina en este periodo. Sin cuentas de control no hay un lado del libro mayor con el que comparar el sistema de nómina.',
  'ave.sec.thControlAccount': 'Cuenta de control',
  'ave.sec.thOpening': 'Saldo inicial',
  'ave.sec.thMovements': 'Movimientos del periodo',
  'ave.sec.thClosing': 'Saldo final contabilizado',
  'ave.sec.thBasis': 'Base calculada',
  'ave.sec.accountsNote': 'Las cuentas de deuda figuran con saldo Haber en el libro mayor. Por eso la comparación se hace sobre el tamaño del movimiento — el signo es el del plan de cuentas, no un error.',
  'ave.sec.quick.needs': 'Requiere valoración',
  'ave.sec.quick.all': 'Todas',
  'ave.sec.quick.change': 'Cambio salarial anómalo',
  'ave.sec.quick.negNet': 'Neto negativo',
  'ave.sec.quick.noAmelding': 'Falta en la A-melding',
  'ave.sec.quick.noTaxCard': 'Falta la tarjeta fiscal (skattekort)',
  'ave.sec.quick.dup': 'Posible duplicado',
  'ave.sec.quick.leaver': 'Empleado que ha dejado la empresa',
  'ave.sec.quick.benefits': 'Retribuciones en especie',
  'ave.sec.quick.notPaid': 'No pagado',
  'ave.sec.quick.done': 'Valoración terminada',
  'ave.sec.card.sysVsLedger': 'Sistema de nómina frente a libro mayor',
  'ave.sec.card.sysVsLedgerHint': 'Las áreas de control en las que el sistema de nómina y el libro mayor no dan la misma cifra.',
  'ave.sec.card.noAmeldingRuns': 'Procesos sin A-melding',
  'ave.sec.card.noAmeldingRunsHint': 'Procesos de nómina contabilizados que no están registrados como declarados.',
  'ave.sec.card.netUnpaid': 'Salario neto no pagado',
  'ave.sec.card.netUnpaidHint': 'Procesos contabilizados sin pago registrado.',
  'ave.sec.card.dupes': 'Posibles pagos duplicados',
  'ave.sec.card.dupesHint': 'El mismo empleado con el mismo importe bruto en varios procesos del periodo.',
  'ave.sec.card.changes': 'Cambios salariales anómalos',
  'ave.sec.card.changesHint': 'Empleados con una desviación de más del 30 % respecto a procesos anteriores del año.',
  'ave.sec.card.holidayDiff': 'Diferencia de paga de vacaciones',
  'ave.sec.card.holidayDiffHint': 'Obligación de paga de vacaciones calculada frente a la contabilizada.',
  'ave.sec.card.negNet': 'Importes netos negativos',
  'ave.sec.card.negNetHint': 'Líneas de nómina en las que las deducciones superan el pago.',
  'ave.sec.card.noTaxCard': 'Empleados sin tarjeta fiscal (skattekort) válida',
  'ave.sec.card.noTaxCardHint': 'La tarjeta fiscal (skattekort) no se ha obtenido o había caducado en la fecha de pago.',
  'ave.sec.card.linesNoAmelding': 'Líneas de nómina sin A-melding',
  'ave.sec.card.linesNoAmeldingHint': 'Líneas de procesos que no están registrados como declarados.',
  'ave.sec.card.leaver': 'Pago a empleado que ha dejado la empresa',
  'ave.sec.card.leaverHint': 'Salario pagado después de la fecha de salida registrada.',
  'ave.sec.card.benefits': 'Retribuciones en especie a revisar',
  'ave.sec.card.benefitsHint': 'Líneas de nómina con retribuciones en especie sujetas a impuestos.',
  'ave.sec.card.accountDev': 'Cuentas de control con desviaciones',
  'ave.sec.card.accountDevHint': 'Cuentas de control en las que el movimiento contabilizado no cuadra con la base.',
  'ave.sec.card.lines': 'Líneas de nómina del periodo',
  'ave.sec.card.linesHint': 'Todas las líneas de los procesos contabilizados.',
  'ave.sec.card.openTerms': 'Plazos de impuestos y cotizaciones abiertos',
  'ave.sec.card.openTermsHint': 'Plazos con retención en origen o cotización del empleador sin liquidar.',
  'ave.sec.card.checksRun': 'Controles automáticos ejecutados: {count}',
  'ave.sec.card.checksWithFindings': 'Controles con hallazgos: {count}',
  'ave.sec.card.flaggedLines': 'Líneas de nómina con aviso: {count}',
  'ave.sec.card.title': 'Tarjeta de control',
  'ave.sec.card.hide': 'Ocultar',
  'ave.sec.card.showAll': 'Mostrar todos los controles automáticos',
  'ave.sec.noRuns': 'Ningún proceso de nómina pertenece a este periodo. Sin procesos no hay nómina que conciliar.',
  'ave.sec.thPayDate': 'Fecha de pago',
  'ave.sec.thPosted': 'Contabilizado',
  'ave.sec.voucher': 'Justificante {number}',
  'ave.sec.reported': 'Declarado',
  'ave.sec.afterPeriod': 'Después del periodo',
  'ave.sec.runsNote': 'Las cifras son las propias de los procesos. La conciliación las compara con el libro mayor — no vuelve a calcular la nómina.',
  'ave.det.am.noRuns': 'No hay procesos que declarar',
  'ave.det.am.allReported': 'Todos los procesos registrados como declarados',
  'ave.det.am.runsMissing': 'Faltan {count} procesos',
  'ave.det.am.runsReported': 'Procesos declarados',
  'ave.det.am.lastSubmitted': 'Última entrega registrada',
  'ave.det.am.recipients': 'Perceptores de ingresos en el periodo',
  'ave.det.am.grossPerSystem': 'Salario bruto según el sistema de nómina',
  'ave.det.agaBase': 'Base de la cotización del empleador',
  'ave.det.agaComputed': 'Cotización del empleador calculada',
  'ave.det.am.runsWithout': 'Procesos sin A-melding registrada',
  'ave.det.am.notReported': 'No declarado',
  'ave.det.am.runLine': '{count} empleados · {money} brutos · fecha de pago {date}',
  'ave.det.am.openTheRun': 'Abrir el proceso',
  'ave.det.am.info': 'La A-melding se presenta en Altinn y se registra manualmente en Plumme. Por eso la conciliación puede confirmar que un proceso se ha declarado, pero no qué cifras recibió Altinn ni qué decía la respuesta. Revisa la respuesta en Altinn antes de enviar el área a revisión.',
  'ave.det.bank.noRuns': 'No hay procesos que pagar',
  'ave.det.bank.allPaid': 'Todo el salario neto está registrado como pagado',
  'ave.det.bank.unpaid': '{money} sin pagar',
  'ave.det.bank.expectedNet': 'Salario neto esperado',
  'ave.det.bank.registeredPaid': 'Pago registrado',
  'ave.det.bank.thExpected': 'Importe esperado',
  'ave.det.bank.thPaid': 'Pagado',
  'ave.det.bank.thPayDate': 'Fecha de pago',
  'ave.det.bank.note': 'Lo pagado después del {date} no es un error — es una diferencia temporal. Aun así hay que valorarlo, porque la obligación sigue en el balance al cierre del periodo.',
  'ave.det.tax.withholdingPeriod': 'Retención en origen del periodo',
  'ave.det.tax.openTerms': 'Plazos abiertos',
  'ave.det.tax.openAmount': 'Importe abierto',
  'ave.det.tax.thTerm': 'Plazo',
  'ave.det.tax.thDue': 'Vencimiento',
  'ave.det.tax.thAga': 'Cotización del empleador',
  'ave.det.tax.paid': 'Pagado',
  'ave.det.tax.thOpen': 'Abierto',
  'ave.det.tax.partlyPaid': 'Pagado parcialmente',
  'ave.det.tax.notPaid': 'No pagado',
  'ave.det.tax.noTerms': 'Ningún plazo de impuestos o cotizaciones afecta a este periodo.',
  'ave.det.hol.noAccountBadge': 'Ninguna cuenta de paga de vacaciones en el área',
  'ave.det.hol.matches': 'La obligación de paga de vacaciones cuadra',
  'ave.det.hol.inDiff': '{money} de diferencia',
  'ave.det.hol.opening': 'Obligación inicial de paga de vacaciones',
  'ave.det.hol.earned': 'Devengado en el periodo',
  'ave.det.hol.paidOut': 'Paga de vacaciones pagada',
  'ave.det.hol.closingComputed': 'Obligación final calculada',
  'ave.det.hol.booked': 'Obligación de paga de vacaciones contabilizada',
  'ave.det.hol.noAccount': 'No se ha añadido ninguna cuenta de paga de vacaciones al área de nómina. Sin la cuenta no hay una obligación contabilizada con la que comparar la calculada.',
  'ave.det.hol.agaOnHoliday': 'Cotización del empleador sobre la paga de vacaciones',
  'ave.det.hol.basis': 'Base',
  'ave.det.hol.rate': 'Tipo',
  'ave.det.hol.computedFee': 'Cotización calculada',
  'ave.det.hol.postedShort': 'Contabilizado',
  'ave.det.hol.pensionTitle': 'Pensión y otras deducciones',
  'ave.det.hol.pensionPremium': 'Prima de pensión según el sistema de nómina',
  'ave.det.hol.pensionBooked': 'Pensión contabilizada',
  'ave.det.hol.holidayBase': 'Base de la paga de vacaciones',
  'ave.det.hol.noPensionAccount': 'El sistema de nómina calcula una prima de pensión, pero no se ha añadido ninguna cuenta de pensión al área de nómina. Sin la cuenta no se puede conciliar la prima con el libro mayor.',
  'ave.det.hol.requestPension': 'Pedir al cliente la base de la pensión',
  'ave.det.doc.thDocument': 'Documento',
  'ave.det.doc.thType': 'Tipo',
  'ave.det.doc.thAdded': 'Añadido',
  'ave.det.doc.fromClient': 'Del cliente',
  'ave.det.doc.addedByFirm': 'Añadido por el despacho',
  'ave.det.doc.none': 'Ningún documento está vinculado al área de nómina en este periodo.',
  'ave.det.doc.note': 'El diario de nómina, los justificantes contables y la base de pago están en los propios procesos de nómina y no son documentos que nadie tenga que subir. Lo que corresponde aquí es la documentación que viene de fuera — facturas de pensión, respuestas de Altinn y contratos.',
  'ave.drw.as.notAssessed': 'Sin valorar',
  'ave.drw.as.noCorrection': 'No se necesita corrección',
  'ave.drw.as.realDeviation': 'Desviación real — confirmada',
  'ave.drw.as.payrollError': 'Error en el sistema de nómina — debe corregirse',
  'ave.drw.as.postingError': 'Contabilización incorrecta — debe corregirse',
  'ave.drw.as.ameldingError': 'Error en la A-melding — requiere corrección',
  'ave.drw.as.paymentError': 'Pago incorrecto',
  'ave.drw.as.timing': 'Diferencia temporal con el banco',
  'ave.drw.as.awaitDocs': 'A la espera de documentación',
  'ave.drw.as.awaitClient': 'A la espera del cliente',
  'ave.drw.as.nextPeriod': 'Seguimiento en el próximo periodo',
  'ave.drw.subtitle': '{run} · {type} · fecha de pago {date}',
  'ave.drw.benefits': 'Retribuciones en especie',
  'ave.drw.holidayAccrued': 'Paga de vacaciones devengada',
  'ave.drw.changeFromPrev': 'Cambio respecto al anterior',
  'ave.drw.noHistory': 'Sin historial',
  'ave.drw.reason': 'Justificación',
  'ave.drw.reasonRequired': 'Justificación (obligatoria)',
  'ave.drw.reasonPlaceholder': '¿Qué muestra la revisión de esta línea de nómina?',
  'ave.drw.measure': 'Medida',
  'ave.drw.measurePlaceholder': 'P. ej.: corregir la A-melding o revertir el pago',
  'ave.drw.deadline': 'Plazo de seguimiento',
  'ave.drw.followUpNote': 'La línea de nómina aparecerá como propuesta de seguimiento en «Conclusión y aprobación».',
  'ave.drw.needsReason': 'Esta valoración requiere una justificación.',
  'ave.drw.save': 'Guardar valoración',
});
